var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import * as React from 'react';
import IconWrap from './icon-wrap';
import AllIcons from './icon-svgs';
var Icon = {};
Object.keys(AllIcons).map(function (icon) {
    Icon[icon] = function (props) { return React.createElement(IconWrap, __assign({ glyph: AllIcons[icon] }, props)); };
});
export default Icon;
//# sourceMappingURL=icon.js.map